import { MessageFilled } from "@ant-design/icons";
import { Flex } from "antd";
import { FC, useCallback } from "react";
import { DmpItem, TaskDMPEntity, TaskStatus } from "tm-shared/types";

import { StatusCycleButton } from "@/domains/tasks";
import { StatusIndicator } from "@/domains/tasks";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledCommentIndicator, StyledTaskDMP } from "./Styled";

interface TaskDMPProps {
    dmp: DmpItem;
    isActive: boolean;
    onChangeActive: (id: string) => void;
    payload: TaskDMPEntity | undefined;
    onChangeTaskStatus: (status: TaskStatus, id?: string) => void;
}

export const TaskDMP: FC<TaskDMPProps> = ({
    dmp,
    isActive,
    onChangeActive,
    payload,
    onChangeTaskStatus,
}) => {
    const { name, subtaskId } = dmp;

    const hasComment = !!payload?.comment;
    const status = payload?.status ?? TaskStatus.Incomplete;
    const photoCount =
        status === TaskStatus.Completed ? payload?.photos?.length : 0;

    const selectTask = useCallback(() => {
        onChangeActive(subtaskId);
    }, [onChangeActive, subtaskId]);

    const handleChangeTaskStatus = useCallback(
        (status: TaskStatus) => {
            onChangeTaskStatus(status, subtaskId);
        },
        [onChangeTaskStatus, subtaskId],
    );

    return (
        <StyledTaskDMP $isActive={isActive} onClick={selectTask}>
            <PrimaryText>{name}</PrimaryText>

            <Flex>
                <StyledCommentIndicator>
                    {hasComment && (
                        <StatusIndicator type="warning">
                            <MessageFilled />
                        </StatusIndicator>
                    )}
                </StyledCommentIndicator>

                <StatusCycleButton
                    value={status}
                    onChange={handleChangeTaskStatus}
                    states={[TaskStatus.Incomplete, TaskStatus.Rejected]}
                    disabled={status === TaskStatus.Completed}
                    photoMode
                    photoCount={photoCount}
                    dimension={48}
                    border={false}
                />
            </Flex>
        </StyledTaskDMP>
    );
};
